
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.9284 8.93939C18.8629 8.78527 18.7567 8.653 18.6217 8.55758C18.4867 8.46216 18.3284 8.40739 18.1645 8.3995H14.1435L16.6585 4.13431C16.694 4.00084 16.699 3.86078 16.6731 3.72501C16.6473 3.58924 16.5912 3.46141 16.5093 3.35146C16.4266 3.24136 16.3201 3.15238 16.1983 3.0915C16.0764 3.03061 15.9425 2.99948 15.8069 3.00053H9.66121C9.463 2.99357 9.26833 3.0556 9.10891 3.17651C8.94949 3.29742 8.8347 3.47009 8.78325 3.6664L5.03034 12.6647C4.99454 12.8006 4.99036 12.9432 5.01814 13.0811C5.04591 13.219 5.10487 13.3483 5.19026 13.4586C5.27566 13.5688 5.38511 13.657 5.50982 13.7161C5.63452 13.7751 5.77101 13.8033 5.90829 13.7985H9.28842L7.69932 19.8633C7.64725 20.0589 7.66114 20.2667 7.73874 20.4532C7.81634 20.6397 7.95309 20.7938 8.12685 20.8907C8.3006 20.9875 8.50117 21.0214 8.69606 20.9868C8.89095 20.9522 9.06874 20.8512 9.20062 20.7001L18.7703 9.90221C18.8843 9.77433 18.9598 9.61546 18.9878 9.44468C19.0159 9.27389 18.9952 9.09845 18.9284 8.93939ZM10.3332 16.7499L11.2814 13.1506C11.321 13.0152 11.3289 12.8721 11.3045 12.733C11.2801 12.5938 11.2241 12.4625 11.1409 12.3497C11.0573 12.2384 10.9495 12.1487 10.826 12.0878C10.7025 12.0268 10.5668 11.9964 10.4298 11.9988H7.05841L10.3372 4.80018H14.1L11.622 9.06537C11.5862 9.20129 11.5821 9.34393 11.6098 9.48181C11.6376 9.61969 11.6966 9.74897 11.782 9.85925C11.8674 9.96953 11.9768 10.0577 12.1015 10.1168C12.2262 10.1758 12.3627 10.204 12.5 10.1992H16.1628L10.3332 16.7499Z","fill":"#10001F"}})])
          )
        }
      }
    